const defaultColors = {
    "color-chart-bar": "#8ccff0",
    // If colors is defined in css, we don't need to define them in defaultColors
    // But if colors use in javascript, we need to define them in defaultColors
};

const astara = {
    "color-primary": "#1E1932",
    "color-bg-8": "#1E1932",
    rgba015: "rgba(30, 25, 50, 0.8)",
    "color-warning": "#FF5A00",
    "color-chart-bar": "#1E1932",
    noImagePicture: "url('/img/astara/no-image.svg')",
};

const themeColors = {
    carconnex: {
        ...defaultColors,
    },
    astara: {
        ...defaultColors,
        ...astara,
    },
};

export default themeColors;
